import { render, staticRenderFns } from "./_userHeader.vue?vue&type=template&id=d88ed472&scoped=true&"
import script from "./_userHeader.vue?vue&type=script&lang=js&"
export * from "./_userHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d88ed472",
  null
  
)

export default component.exports